module.exports = __webpack_public_path__ + "static/media/font-icon-active.f5c755e7.svg";